import { Formik } from 'formik';
import { useMutation } from 'react-query';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { getApiMutation } from '../../../services/rest/getApiMutation';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteAgentNumberModal({
  selected,
  setSelected,
  show,
  handleClose,
  userAtom,
  setUserAtom,
  enqueueSnackbarWithStyles,
  setRefetchToggleForAgentNumbers,
  setSelectedToggle,
}) {
  const mutation = useMutation(getApiMutation(userAtom.contents, setUserAtom));
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (values.selected.length) {
          setSelectedToggle((prev) => !prev);
          let errors = false;
          for (let i = 0; i < values.selected.length; i++) {
            // await makeRequest({
            //   methodName: methodNameEnum.DELETE_NUMBER,
            //   payload: {
            // numberid: values.selected[i].id,
            //   },
            // });
            const data = {
              role: userAtom.contents.user.role,
              call: methodNameEnum.DELETE_NUMBER,
              apikey: userAtom.contents.apikey,
              businessid: userAtom.contents.businessid,
              numberid: values.selected[i].id,
            };
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_NUMBER,
              payload: data,
            });
            if (!response?.data?.success) {
              errors = true;
              break;
            }
          }
          setRefetchToggleForAgentNumbers({});
          if (!errors) {
            enqueueSnackbarWithStyles({
              message: `Successfully Deleted ${values.selected.length} Number(s)`,
              alertProps: { severity: 'success' },
            });
          } else {
            enqueueSnackbarWithStyles({
              message:
                'Looks like we encountered an error deleting these number(s)',
              alertProps: { severity: 'error' },
            });
          }
          setSelected([]);
          handleClose();
          actions.resetForm({});
        }
      }}
      enableReinitialize={true}
      initialValues={{ selected: selected ?? [] }}
    >
      {(formik) => (
        <ModalWithStyles
          onSubmit={formik.handleSubmit}
          title="Delete Number(s)"
          aria-labelledby="example-modal-sizes-title-md"
          show={show}
          onHide={handleClose}
          isSubmitting={formik.isSubmitting}
          size="xs"
          deleteDialog={true}
        >
          <p>
            You are about to delete {formik.values.selected.length} Number(s),
            this procedure is not reversible.
          </p>
          <p> Do you want to proceed?</p>
        </ModalWithStyles>
      )}
    </Formik>
  );
}
